export const driverInfoFormMessages = {
  mobileNumber:
    'Número inválido. Verifique se digitou corretamente e tente de novo.',
  invalidMobileNumber: 'Eita! Ficou faltando seu telefone'
};

const errorsMessage = { driverInfoFormMessages };

export default errorsMessage;
